
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/insurancesupersaver",
      function () {
        return require("private-next-pages/insurancesupersaver/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/insurancesupersaver"])
      });
    }
  